import {
    HotkeyBinding,
    View,
} from 'radpresentation.htmlclient.defaultviewextensions';
import type ConnectPropertyGroupViewViewModel from '@/ViewModels/Views/ConnectPropertyGroupViewViewModel';
import layout from './ConnectPropertyGroupView.html?raw';

class ConnectPropertyGroupView extends View {
    private view: JQuery<HTMLElement>;

    constructor(
        private viewModel: ConnectPropertyGroupViewViewModel,
        private element: any
    ) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        HotkeyBinding.addHotkey(
            this.view[0],
            'esc',
            this.viewModel.cancel.onClick.bind(this)
        );

        return this.view;
    }
}

export default ConnectPropertyGroupView;
